<template>
  <v-dialog
    v-model="showCurrentSituationTypeDialog"
    width="500"
    v-if="currentSituation.carrier==null"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        @click="loadProductFamily"
        class="mb-5"
        v-if="currentSituation.carrier==null"
      >
        <v-icon small title="Criar">fas fa-plus</v-icon>
      </v-btn>
    </template>

    <v-card
      elevation="2"
      outlined
    >
      <v-card-title class="text-h5 muted lighten-2">
        Operadora
      </v-card-title>

      <v-card-text>
        <br>
        <v-autocomplete
          label="Operadora"
          v-model="value"
          :items="currentSituationTypeItems"
          item-text="comercialName"
          item-value="id"
          outlined
          dense
          return-object
          :loading="this.currentSituationTypeItems.length == 0"
        ></v-autocomplete>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          @click="linkCarrierWithCarrierCurrentSituation"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CarrierService from "@/services/odoo/CarrierService";

export default {
  props:{
    currentSituation: {
      type: Object
    },
    benefit:{
      type: Object
    },
    carrierCurrentPlans: {
      type: Object
    }
  },
  data() {
    return {
      showCurrentSituationTypeDialog: false,
      currentSituationTypeItems: [],
      provider: {},
      value : null
    }
  },
  async created() {
    this._carrierService = new CarrierService();
  },
  methods: {
    linkCarrierWithCarrierCurrentSituation(){
      this.showCurrentSituationTypeDialog = false; 
      this.currentSituation.carrier=this.value;
      this.value=null;
      this.carrierCurrentPlans.carrier=this.currentSituation.carrier;
    },
    async loadProductFamily(){
      if (this.currentSituationTypeItems.length==0) {
        const { data } = await this._carrierService.findAllByParams(
          Object.assign(
            this.provider,
            {
              benefitId: this.benefit.id,
              page: 0,
              sortBy: 'name',
              descending: false,
              size: '1000'
            }
          )
        );
        this.currentSituationTypeItems = data.content;
      }
    }
  },
  name: "dlg_health_care_provider"
}
</script>

<style scoped>

</style>
